// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import config from '../../config/config';
import axiosBaseQuery from './axiosBaseQuery/axiosBaseQuery';
import { ApiResponse, TeamRecord } from './types/types';

// Define a service using a base URL and expected endpoints
export const teamsAPI = createApi({
  reducerPath: 'teamsAPI',
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  endpoints: (builder) => ({
    getTeams: builder.query<TeamRecord[], void>({
      query: () => ({
        url: `/auth/team`,
        method: 'GET',
      }),
      transformResponse: (response: ApiResponse<TeamRecord[]>) => response.body,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTeamsQuery } = teamsAPI;
